export class Bookmark {
    constructor() {
        let _this = this;

        $('.c-agenda__bookmark i').on('click', function() {
            _this.toggle($(this));
        });
    }

    toggle($element) {
        let $form = $element.parent();

        $element.toggleClass('fa-heart-o fa-heart');
        this.toggleAgendaLink();
        $form.find('[name="value"]').val(($element.hasClass('fa-heart')) ? 1 : 0);

        this.save($form);
    }

    toggleAgendaLink() {
        let $bookmarkedSessions = $('.c-agenda__bookmark .fa-heart');
        let $agendaLink = $('.c-agenda__myagenda');

        if ($bookmarkedSessions.length > 0) {
            $agendaLink.removeClass('c-agenda__myagenda--hidden');
        } else {
            $agendaLink.addClass('c-agenda__myagenda--hidden');
        }
    }

    save($form) {
        $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function(data) {
                //console.log(data);
            }
        });
    }
}
